import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}(); // Internal Imports


import { AxisChart } from "../axis-chart";
import * as Configuration from "../configuration";
import { Tools } from "../tools";
import { Skeletons } from "../interfaces/enums"; // Components

import { Grid, StackedBar, StackedBarRuler, TwoDimensionalAxes, Skeleton } from "../components/index";

var StackedBarChart =
/** @class */
function (_super) {
  __extends(StackedBarChart, _super);

  function StackedBarChart(holder, chartConfigs) {
    var _this = _super.call(this, holder, chartConfigs) || this; // Merge the default options for this chart
    // With the user provided options


    _this.model.setOptions(Tools.mergeDefaultChartOptions(Configuration.options.stackedBarChart, chartConfigs.options)); // Initialize data, services, components etc.


    _this.init(holder, chartConfigs);

    return _this;
  }

  StackedBarChart.prototype.getComponents = function () {
    // Specify what to render inside the graph-frame
    var graphFrameComponents = [new TwoDimensionalAxes(this.model, this.services), new Grid(this.model, this.services), new StackedBarRuler(this.model, this.services), new StackedBar(this.model, this.services), new Skeleton(this.model, this.services, {
      skeleton: Skeletons.VERT_OR_HORIZ
    })];
    var components = this.getAxisChartComponents(graphFrameComponents);
    return components;
  };

  return StackedBarChart;
}(AxisChart);

export { StackedBarChart };